/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { userContext } from '../../../../contextProvider/Authentication';
import axiosInstance from '../../../../services/AxiosInstance';
import Pagination from '../../../../components/Pagination';

const SavedJobs = () => {

	const { user } = useContext(userContext);

	const [jobs, setJobs] = useState([]);

	useEffect(() => {
		getData();
	}, []);

	const getData = (page = 1) => {
		axiosInstance('can-applyjob/?user=' + user.id + '&status=s&page=' + page, { method: "GET" })
			.then(res => setJobs(res?.data))
	}

	const handleDeleteClick = (id) => {
		axiosInstance(`can-applyjob/${id}`, { method: "DELETE" })
			.then(res => { if (res.status === 204) getData(); })
	}

	return (
		<>
			<div className="job-bx save-job browse-job table-job-bx clearfix">
				<div className="job-bx-title clearfix">
					<h5 className="font-weight-700 pull-left text-uppercase">{jobs?.pagination?.totalEntries} Saved Jobs</h5>
					<div className="float-right">
						<span className="select-title">Sort by freshness</span>
					</div>
				</div>
				<table>
					<thead>
						<tr>
							<th>Premium jobs</th>
							<th>Company</th>
							<th>Date</th>
							<th>Action</th>
						</tr>
					</thead>
					<tbody>
						{jobs?.results?.length > 0 ? jobs?.results?.map((job, index) => (
							<tr key={index}>
								<td className="job-name"><Link to={`/job-detail/${job?.job}`}>{job?.job_name}</Link></td>
								<td className="criterias text-primary"><Link to={"#"}>{job?.company}</Link></td>
								<td className="date">{job?.created_on}</td>
								<td className="job-links pencil">
									<Link to={"#"}
										title="Click to remove from saved jobs"
										onClick={() => handleDeleteClick(job?.id)}
									>
										<i className="ti-trash"></i>
									</Link>
								</td>
							</tr>
						)) :
							<tr>
								<td colSpan="4" className="text-center">
									<div className="alert alert-danger">
										<h5 className="text-center">No Data Found</h5>
									</div>
								</td>
							</tr>
						}
					</tbody>
				</table>
				{jobs?.length > 0 && <Pagination data={jobs} getData={getData} />}
			</div>
		</>
	)
}
export default SavedJobs;